// extracted by mini-css-extract-plugin
export var root = "VisuallyHidden-module--root--ef8d5";